import {
  CopyOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
} from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import { TableActionHeader } from "components/Global";
import EmbedScript from "components/Global/EmbedScriptModal";
import { FORMDATA } from "constants/Data";
import IntegrationLayout from "layouts/Settings/Integration";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { GetIntegrationAction } from "redux/action/IntegrationAction";
import { AppDispatch } from "redux/store";
import { toastText } from "utils/utils";
import styles from "./index.module.scss";

export default function IntegrationPage() {
  const location = useLocation();
  const { newIntegrationMenuItems } = FORMDATA;

  // Get the current pathname and initialize selectedSidebar with the last segment.
  const pathname = window.location.pathname;
  const pathSegments = pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];
  // const currentUrl = window.location.href;
  // const [baseUrl] = currentUrl.split("/integrations/accounting");
  const companyId = localStorage.getItem("companyId") || "";
  const maskedId =
    companyId.slice(0, -3).replace(/./g, "*") + companyId.slice(-3);

  const dispatch = useDispatch<AppDispatch>();

  const [selectedSidebar, setSelectedSidebar] = useState<string>(lastSegment);
  const [previewDisable, setPreviewDisable] = useState<boolean>(true);
  const [visible, setVisible] = useState<boolean>(false);
  const [isEmbedModalOpen, setIsEmbedModalOpen] = useState<boolean>(false);

  const integrationList = useSelector((state: any) => state?.Integration?.data);

  const onApps = integrationList?.filter((items: any) => items?.isOn === true);

  const navigate = useNavigate();

  const handleCopy = () => {
    navigator.clipboard.writeText(companyId);
    toastText("Tenant ID copied to clipboard!", "success");
  };

  // Handle sidebar selection change.
  const sideBarChangeHandler = (selectedValue: any) => {
    navigate(selectedValue.key);
  };

  // Initialize selectedSidebar based on the current pathname.
  const initialFunction = () => {
    const splitArray = pathname.split("/");
    setSelectedSidebar(splitArray[splitArray.length - 1]);
  };

  // const previewHandler = () => {
  //   navigate("preview/connectedApps");
  // };

  // Call initialFunction when the component mounts or the window location changes.
  useEffect(() => {
    initialFunction();
  }, [window.location.href]);

  useEffect(() => {
    dispatch(GetIntegrationAction(""));
  }, []);

  useEffect(() => {
    if (onApps?.length > 0) {
      setPreviewDisable(false);
    }
  });

  const handleCancel = () => {
    setIsEmbedModalOpen(false);
  };
  const handleOk = () => {
    setIsEmbedModalOpen(false);
  };

  // Render the component.
  return (
    <div>
      <TableActionHeader
        title={`${
          location.pathname !== "/integrations/connectedapps"
            ? "Configuration"
            : "Companies"
        }`}
      >
        {location.pathname !== "/integrations/connectedapps" && (
          <div
            className={styles["user-table__action"]}
            style={{ display: "flex", gap: 20 }}
          >
            {/* {localStorage.getItem("companyId") !== "undefined" && DashboardPermission?.add && ( */}
            <button
              className={`btn-blue ${styles["user-table__action--button"]}`}
              onClick={() => {
                setIsEmbedModalOpen(true);
              }}
            >
              <p>Embed</p>
            </button>
            {/* {localStorage.getItem("companyId") !== "undefined" && DashboardPermission?.add && ( */}
            <a
              style={{ color: "white" }}
              target="_blank"
              href={`${window.location.origin}/preview?t=${btoa(
                companyId ? companyId : "companyId"
              )}`}
              rel="noreferrer"
            >
              {" "}
              <button
                className={"btn-blue"}
                // style={{
                //   backgroundColor: previewDisable ? "gray" : "#0b78c2",
                //   cursor: previewDisable ? "not-allowed" : "pointer",
                // }}
                // onClick={previewHandler}
                disabled={previewDisable}
              >
                Preview
              </button>
            </a>
          </div>
        )}
        {location.pathname === "/integrations/connectedapps" && (
          <Tag className={`${styles["organization-tag"]} tag`} color="#fff">
            <div className={styles["organization-tag__content"]}>
              <Tooltip
                title="This is the tenant id for the respected user"
                placement="left"
              >
                <span className={styles["organization-tag__content--id"]}>
                  Organization ID: {!visible ? maskedId : companyId}
                </span>
              </Tooltip>

              <div className={styles["organization-tag__content--actions"]}>
                <Tooltip
                  title={
                    visible ? "Hide Organization ID" : "Show Organization ID"
                  }
                >
                  <div
                    className={styles["visibility-toggle"]}
                    onClick={() => setVisible(!visible)}
                  >
                    {visible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                  </div>
                </Tooltip>

                <Tooltip title="Copy Organization ID">
                  <div className={styles["copy-button"]} onClick={handleCopy}>
                    <CopyOutlined />
                  </div>
                </Tooltip>
              </div>
            </div>
          </Tag>
        )}
      </TableActionHeader>
      {location.pathname !== "/integrations/connectedapps" ? (
        <IntegrationLayout
          onSideBarChange={sideBarChangeHandler}
          selectedSidebar={selectedSidebar}
          sidebarMenu={newIntegrationMenuItems}
        >
          <Outlet />
        </IntegrationLayout>
      ) : (
        <Outlet />
      )}
      {isEmbedModalOpen && (
        <EmbedScript
          isModalOpen={isEmbedModalOpen}
          handleOk={handleOk}
          handleCancel={handleCancel}
        />
      )}
    </div>
  );
}
